import React, { createContext } from 'react';
import { ThemeProvider as ProviderTheme } from '@oneaudi/unified-web-common';
import type { ThemeName } from '@oneaudi/unified-web-common/dist/cjs/components/theme-provider/theme';
import ProviderI18n from '@oneaudi/i18n-context';

import { FootnoteContextProvider as ProviderFootnote } from '@oneaudi/feature-app-utils';

import type { TrackingServiceV2 } from '@oneaudi/audi-tracking-service';

import type { LocaleServiceV1 } from '@volkswagen-onehub/locale-service';
import type { VueFormatterFeatureServiceInterfaceV1 } from '@oneaudi/vue-formatter-service/lib/cjs/v1/vue-formatter-feature-service';

import { adapterContent } from '../adapterContent';
import { getThemeName } from '../../alpha-helper';

export const ContextServiceTracking = createContext<TrackingServiceV2 | undefined>(undefined);
export const ContextLocaleService = createContext<LocaleServiceV1 | undefined>(undefined);
export const ContextVueFormatter = createContext<VueFormatterFeatureServiceInterfaceV1 | undefined>(
  undefined,
);
export const ContextServiceContent = createContext<ContentApp | undefined>(undefined);

const ProviderTracking = ContextServiceTracking.Provider;
const ProviderLocale = ContextLocaleService.Provider;
const ProviderVueFormatter = ContextVueFormatter.Provider;
const ProviderContent = ContextServiceContent.Provider;

export const Providers: React.FC<ProvidersProps> = ({
  children,
  content,
  i18nData,
  i18nLanguage,
  serviceTracking,
  serviceLocale,
  serviceVueFormatter,
  serviceFootnote,
}: ProvidersProps) => {
  const adaptedContent = adapterContent(content);

  let theme = 'light';
  if (adaptedContent && adaptedContent.theme) {
    theme = adaptedContent.theme;
  }

  return (
    <div data-testid="Providers">
      <ProviderTheme theme={{ name: getThemeName(theme as ThemeName) }}>
        <ProviderFootnote footnoteReferenceService={serviceFootnote.getDefaultScopeRefService()}>
          <ProviderContent value={adaptedContent}>
            <ProviderTracking value={serviceTracking}>
              <ProviderI18n i18nData={i18nData} language={i18nLanguage} scopes={['fa.carousel']}>
                <ProviderLocale value={serviceLocale}>
                  <ProviderVueFormatter value={serviceVueFormatter}>
                    {children}
                  </ProviderVueFormatter>
                </ProviderLocale>
              </ProviderI18n>
            </ProviderTracking>
          </ProviderContent>
        </ProviderFootnote>
      </ProviderTheme>
    </div>
  );
};

export default Providers;
